import { render, staticRenderFns } from "./KycReminder.vue?vue&type=template&id=031ab2a2&scoped=true"
import script from "./KycReminder.vue?vue&type=script&lang=js"
export * from "./KycReminder.vue?vue&type=script&lang=js"
import style0 from "./KycReminder.vue?vue&type=style&index=0&id=031ab2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ab2a2",
  null
  
)

export default component.exports